import IconOne from "src/assests/choose1.png"
import IconTwo from "src/assests/choose2.png"
import IconThree from "src/assests/choose3.png"


export const whyChooseUs = [
    {
        icon: IconOne,
        heading: "decentralized",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Felis vitae ligula gravida mauris, lectus. Penatibus enim mattis sit a. ",
    },
    {
        icon: IconTwo,
        heading: "fast",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Felis vitae ligula gravida mauris, lectus. Penatibus enim mattis sit a. ",
    },
    {
        icon: IconThree,
        heading: "Secure",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Felis vitae ligula gravida mauris, lectus. Penatibus enim mattis sit a. ",
    },
]